import { RegexOption } from 'src/shared/constants/regex-formats/types/RegexTypes';

export const textRegexOptions: RegexOption[] = [
  {
    type: 'text',
    display: 'Text',
    code: 'Anything',
    icon: 'TextAlignStart',
    regex: "[A-Za-z0-9 €£$\\[!#\\]%&()*+,\\-'./:;<=>@?_ÈÉÊË©®àáâãäåæœçèéêëìíîïðñòóôõöùúûüý]*",
    examples: ['Hello', 'Hello, World!'],
  },
  {
    type: 'text-alphanumeric',
    display: 'No Special Characters',
    code: 'Alphanumeric',
    icon: 'CaseSensitive',
    regex: '^[A-Za-z0-9\\s]+$',
    examples: ['Hello', 'Hello World'],
  },
  {
    type: 'text-email',
    display: 'Email',
    code: 'name@domain.com',
    icon: 'Mail',
    regex: '^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$',
    examples: ['test@example.com', 'user@domain.co.uk'],
  },
  {
    type: 'text-phone',
    display: 'Phone Number',
    code: '+1234567890',
    icon: 'Phone',
    regex: '^\\+?[1-9]\\d{1,14}$',
    examples: ['+1234567890', '+12345678901234567890'],
  },
  {
    type: 'text-url',
    display: 'URL',
    code: 'https://www.example.com',
    icon: 'Link',
    regex: '^(https?://|www\\.)?[-a-zA-Z0-9]+\\.[-a-zA-Z0-9\\.]+$',
    examples: ['https://www.example.com', 'http://example.com', 'www.example.com', 'example.com'],
  },
];
